<template>
  <b-row align-h="center">
    <div class="w-75">
      <FITFormCard>
        <div slot="header">
          <b-row align-v="center">
            <b-col cols="6">
              <h4>{{$t('osm.claim.detail.header')}}</h4></b-col>
            <b-col cols="auto" class="ml-auto">
              <p class="h5 text-white ml-auto p-2 rounded" :class="{'bg-danger': status === 'R', 'bg-primary': status === 'C'}">{{ $t('general.status') }}: {{getTranslatedContent('status',status)}}</p>
            </b-col>
          </b-row>
        </div>
        <div slot="formBody">
          <b-row>
            <b-col cols="6">
              <span class="row">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.policy')}}</dt>
                <dd :class="`col-${columnsWidth}`">{{productName}}</dd>
              </span>
              <span class="row">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.policyReference')}}</dt>
                <dd :class="`col-${columnsWidth}`">{{detail.policyReference}}</dd>
              </span>
              <span class="row">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.expectedClaimAmount')}}</dt>
                <dd :class="`col-${columnsWidth}`">$ {{detail.expectedClaimAmount}}</dd>
              </span>
              <span class="row mt-4">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.remark')}}</dt>
                <dd :class="`col-${columnsWidth}`">{{detail.remark | isEmpty}}</dd>
              </span>
            </b-col>
            <b-col cols="6">
              <span class="row">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.claimRequestDate')}}</dt>
                <dd :class="`col-${columnsWidth}`">{{detail.claimRequestDate | date}}</dd>
              </span>
              <span class="row">
                <dt :class="`col-${12 - columnsWidth}`">{{$t('osm.claim.claimResponseDate')}}</dt>
                <dd :class="`col-${columnsWidth}`">{{detail.claimResponseDate | date}}</dd>
              </span>
              <template>
                <dl class="row">
                  <dt :class="`col-${12 - columnsWidth}`">
                    <p>{{$t('osm.claim.attachment')}}</p>
                  </dt>
                  <dd :class="`col-${columnsWidth}`">
                    <ul class="list-unstyled">
                      <template v-for="(item,index) in files">
                        <b-row align-v="center">
                          {{index + 1}}.
                          <b-btn variant="link" class="m-0 ml-2 p-0" @click="fileDownload(item.ID,item.documentName)">{{item.documentName}}</b-btn>
                        </b-row>
                      </template>
                      <li v-if="files.length == 0">N/A</li>
                    </ul>
                  </dd>
                </dl>
              </template>
            </b-col>
          </b-row>
          <b-row v-if="claimResults.length > 0">
            <b-col>
              <hr>
              <h4>{{$t('osm.claim.claimResult')}}</h4>
              <template v-for="(item,index) in claimResults">
                <b-row align-v="center">
                  <hr>
                  <b-col cols="2" class="text-center">
                    <h4>{{index + 1}}.</h4>
                  </b-col>
                  <b-col cols="10">
                    <b-row>
                      <b-col cols="6">
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.claimIssueDate')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{claimResults[index].claimIssueDate | date}}</dd>
                        </span>
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.companyReceiveDate')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{claimResults[index].companyReceiveDate | date}}</dd>
                        </span>
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.agentReceiveDate')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{claimResults[index].agentReceiveDate | date}}</dd>
                        </span>
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.customerReceiveDate')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{claimResults[index].customerReceiveDate | date}}</dd>
                        </span>
                      </b-col>
                      <b-col cols="6">
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.claimAmount')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">$ {{claimResults[index].claimAmount}}</dd>
                        </span>
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.claimPaymentMethod')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{getTranslatedContent('claimPaymentMethod',claimResults[index].claimPaymentMethod)}}</dd>
                        </span>
                        <span class="row">
                          <dt :class="`col-${12 - claimResultColumnWidth}`">{{$t('osm.claim.claimReference')}}</dt>
                          <dd :class="`col-${claimResultColumnWidth}`">{{claimResults[index].claimReference}}</dd>
                        </span>
                      </b-col>
                      <b-col cols="12" class="mt-4">
                        <span class="row">
                          <dt class="col-3">{{$t('osm.claim.remark')}}</dt>
                          <dd class="col-9">{{claimResults[index].remark}}</dd>
                        </span>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </template>
            </b-col>
          </b-row>
        </div>
      </FITFormCard>
    </div>
  </b-row>
</template>
<script type="text/javascript">
import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
import { FITFormCard, FITButton, } from '@/components'

import { saveAs } from 'file-saver/FileSaver';
export default {
  name: 'ClaimDetail',
  props: {
    detail: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      policyID: 0,
      policyType: null,
      claimType: null,
      policyName: '',
      remark: '',
      expectedClaimAmount: 0,
      claimRequestDate: '',
      claimResponseDate: '',
      companyReceiveDate: '',
      claimResults: [],
      status: 'C',
      files: []
    }
  },
  methods: {
    fileDownload(ID, fileName) {
      this.$store.dispatch('fileDownload', ID).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        saveAs(new Blob([json.data]), fileName);
      }).catch((err) => {
        console.error(err);
      })
    },
    getTranslatedContent(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Claim', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    },
  },
  created() {
    this.$store.dispatch('getAllSelections', 'claim')
      .then((json) => {
        this.$store.commit({ type: 'Claim/setSelections', selections: json.data });
      })
      .catch((err) => {
        console.error(err);
      })
    this.$store.dispatch('Claim/getClaimDetail', { ID: this.detail.ID }).then((json) => {
      Vue.set(this, 'policyID', json.data.policyID);
      Vue.set(this, 'policyType', json.data.policyType);
      Vue.set(this, 'policyName', this.$options.filters.isUndifined(json.data.productEnglishName) + ' ' + this.$options.filters.isUndifined(json.data.productChineseName));
      Vue.set(this, 'claimRequestDate', json.data.claimRequestDate);
      Vue.set(this, 'claimType', json.data.claimType);
      Vue.set(this, 'expectedClaimAmount', json.data.expectedClaimAmount);
      Vue.set(this, 'remark', json.data.remark);
      Vue.set(this, 'status', json.data.status);
      Vue.set(this, 'claimResults', JSON.parse(JSON.stringify(json.data.claimResults)))
      Vue.set(this, 'files', json.data.files);
    }).catch((err) => {});
  },
  computed: {
    ...mapGetters(['getTranslatedArray']),
    productName() {
      return this.$options.filters.isEmpty(this.detail.productEnglishName) + ' ' + this.$options.filters.isEmpty(this.detail.prodcutChineseName);
    },
    columnsWidth() { return 8 },
    claimResultColumnWidth() {
      return 7
    }
  },
  components: {
    FITFormCard,
    FITButton
  },
  filters: {
    isUndifined: function(value) {
      return value ? value : ''
    }
  },
}

</script>



// WEBPACK FOOTER //
// src/Osm/Claim/containers/ClaimDetail.vue